import Nullstack from 'nullstack';
export default function IconSortDescendingNumbers({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sort-descending-numbers",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 15l3 3l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M7 6v12"
  }), "   ", Nullstack.element("path", {
    d: "M17 14a2 2 0 0 1 2 2v3a2 2 0 1 1 -4 0v-3a2 2 0 0 1 2 -2z"
  }), "   ", Nullstack.element("circle", {
    cx: "17",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M19 5v3a2 2 0 0 1 -2 2h-1.5"
  }), " ");
}